export default "/palm/assets/images/locked.svg"